import { shortDateFrom } from '../utils/date';
import Popup from './Popup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { Milestone } from './Timeline';

interface Props {
  x: number;
  y: number;
  milestone: Milestone;
  isOpen: boolean;
  onEdit: (id: string, milestone: Milestone, keepEditing?: boolean) => void;
}

export default ({ x, y, milestone, isOpen, onEdit }: Props) => {
  const { id } = milestone;
  function complete(title, keepEditing = false) {
    onEdit(
      id,
      {
        ...milestone,
        title,
      },
      keepEditing
    );
  }
  function close() {
    complete(milestone.title, false);
  }
  const handleTitleChange = e => {
    const title = e.currentTarget.value;
    complete(title, true);
  };
  const handleClose = () => {
    close();
  };
  const handleDelete = () => {
    onEdit(id, {
      ...milestone,
      title: '',
    });
  };

  const handleKeyPress = e => {
    if (e.keyCode === 27) {
      // Escape
      close();
    } else if (e.keyCode === 13) {
      // Enter
      close();
    }
  };

  const handleFocus = e => e.currentTarget.select();
  const colorBg = 'red-700';
  const colorFg = 'white';

  return (
    <Popup x={x} y={y + 72} width={385} height={165} isOpen={isOpen} onClose={handleClose}>
      <div
        className={`flex flex-col items-center justify-start h-full w-full px-8 pt-5 pb-8 bg-${colorBg}`}
      >
        <div className="flex items-center justify-end w-full">
          <div>
            <FaRegTrashAlt
              className={`p-2 text-${colorFg} text-opacity-75 cursor-pointer`}
              onClick={handleDelete}
              size={33}
            />
          </div>
          <div>
            <MdClose
              className={`p-2 -mr-4 text-${colorFg} text-opacity-75 cursor-pointer`}
              onClick={handleClose}
              size={35}
            />
          </div>
        </div>
        <input
          className={`w-full pt-3 pb-2 text-${colorFg} placeholder-opacity-25 placeholder-${colorFg} text-lg font-semibold bg-transparent focus:outline-none`}
          autoFocus
          type="text"
          value={milestone.title}
          placeholder="New milestone"
          onChange={handleTitleChange}
          onKeyDown={handleKeyPress}
          onFocus={handleFocus}
        />
        <div className={`text-${colorFg} text-left w-full text-opacity-75 text-md`}>
          {shortDateFrom(milestone.date)}
        </div>
      </div>
    </Popup>
  );
};
